import { render } from "./exceptionMessage.vue?vue&type=template&id=2f71e6dc"
import script from "./exceptionMessage.vue?vue&type=script&lang=js"
export * from "./exceptionMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__